// What a listing save sends to the hub (POST /local/xdata/:id).
//
// The listing rows edit the loaded xdata in place and used to post the WHOLE object,
// so a save carried back every field as it was when the page loaded. Since
// 2026-10-26 the hubs take only the fields these pages edit and keep the rest as
// stored (SHub / VTHub api/utils/xdataSave.js, same list); the page now sends only
// those fields too.
export const XDATA_EDITABLE = ['title', 'desc', 'tags', 'agent', 'status', 'pictures', 'channel', 'newListing', 'region']

/** The editable fields of an xdata object, nothing else. */
export const editableXdata = (xdata) => {
  const out = {}
  for (const key of XDATA_EDITABLE) {
    if (xdata && xdata[key] !== undefined) out[key] = xdata[key]
  }
  return out
}

/** POST the save; a refused save (404 / 400 / 500) answers like a failed one instead of throwing. */
export const postXdataSave = async (request, url, xdata) => {
  try {
    return await request.post(url, editableXdata(xdata))
  } catch (error) {
    return error?.response || { data: { success: false, error: error?.message || 'save failed' } }
  }
}
